import { SUBSCRIPTION_DASHBOARD_LEGACY_API } from '../constants/AppConstants';

export default async (orgId) => {
  try {
    const response = await fetch(SUBSCRIPTION_DASHBOARD_LEGACY_API.replace(':orgId', orgId));
    const json = await response.json();
    if (response.status !== 200) return { ok: false, json };
    return { ok: true, json };
  } catch (error) {
    return { ok: false, json: { errorDescription: 'Internal Server Error' } };
  }
};
